import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { ARC } from '@/components/generals/arcade'
import { RESUME } from '@/components/landing/cabinet/data'
import { NAV_LINKS } from '@/constants/site'

const EMAIL = RESUME.contact.find((c) => c.label === "Email")
const LOCATION = RESUME.contact.find((c) => c.label === "Location")

const LINK =
    'pb-1 text-(--cab-cream) no-underline bg-[linear-gradient(var(--cab-tan),var(--cab-tan))] bg-no-repeat bg-[length:0_2px] bg-bottom-left transition-[background-size] hover:bg-[length:100%_2px] hover:text-(--cab-tan) focus-visible:outline-3 focus-visible:outline-offset-4 focus-visible:outline-dashed focus-visible:outline-(--cab-tan)'

/* the base of the cabinet, shown under the inner pages */
export const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='bg-[#26323b] text-(--cab-cream) shadow-[0_-3px_0_#1d272e]'>
            <div className='mx-auto flex max-w-[1240px] flex-wrap items-center justify-between gap-6 px-5 pt-10 pb-7 md:px-12'>
                <div className='flex flex-col gap-1.5'>
                    <p className={cn(ARC.pixel, 'm-0 text-lg font-bold tracking-[0.03em] text-(--cab-cream-hi) [text-shadow:0_3px_0_var(--cab-teal)] md:text-2xl')}>
                        {RESUME.name}
                    </p>
                    <p className='m-0 text-[15px] text-[#c9c2ad]'>
                        {RESUME.role}
                        {LOCATION && <> · {LOCATION.value}</>}
                    </p>
                </div>

                <nav aria-label="Footer">
                    <ul className='m-0 flex list-none flex-wrap gap-x-7 gap-y-2.5 p-0'>
                        {NAV_LINKS.map((link) => (
                            <li key={link.href}>
                                <Link href={link.href} className={cn(ARC.pixel, 'text-xs tracking-[0.08em]', LINK)}>
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>

            <div className='mx-auto flex max-w-[1240px] flex-wrap justify-between gap-x-6 gap-y-2 border-t-[3px] border-[#1d272e] px-5 pt-4.5 pb-6 text-sm text-[#c9c2ad] md:px-12'>
                <p className='m-0'>
                    © {RESUME.year} {RESUME.name}
                </p>
                {EMAIL?.href && (
                    <a href={EMAIL.href} className={LINK}>
                        {EMAIL.value}
                    </a>
                )}
            </div>
        </footer>
    )
}
